import { render, staticRenderFns } from "./modalInactivarTienda.vue?vue&type=template&id=4754ef4d&scoped=true"
import script from "./modalInactivarTienda.vue?vue&type=script&lang=js"
export * from "./modalInactivarTienda.vue?vue&type=script&lang=js"
import style0 from "./modalInactivarTienda.vue?vue&type=style&index=0&id=4754ef4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4754ef4d",
  null
  
)

export default component.exports